import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import base from '../base';
import TaskButton from './TaskButton';
import TaskForm from './TaskForm';

const TaskContainer = styled.div`
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
`

const TaskListContainer = styled.div`
    margin: 0 25px;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;
    overflow: auto;
    flex-wrap: wrap;
    max-width: 1024px;
`


class Tasks extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            tasks: [],
            events: []
        }
        
        this.startTimer = this.startTimer.bind(this);
        this.createTask = this.createTask.bind(this);
    }

    componentDidMount() {
        this.taskRef = base.syncState(`/tasks/${this.props.uid}`, {
            context: this,
            state: 'tasks',
            asArray: true
        });

        this.eventRef = base.syncState(`/events/${this.props.uid}`, {
            context: this,
            state: 'events',
            asArray: true
        });
      }
    
    componentWillUnmount() {
        // Remove the reference for listening.
        base.removeBinding(this.taskRef);
        base.removeBinding(this.eventRef);
    }

    createTask(task) {
        base.push(`/tasks/${this.props.uid}`, {
            data: task
        });
    }

    createEvent(event) {
        base.push(`/events/${this.props.uid}`, {
            data: event
        });
    }

    startTimer(e) {
        // Grab the current timestamp for later.
        const timestamp = moment();
        // Duplicate the current task list.
        let newTaskList = [...this.state.tasks];
        // Get the current task (the one we're starting).
        const currentTask = newTaskList.find((task) => {
            return task.key === e.target.id;
        });

        // Show that the current task is already running.
        if ( currentTask.isActive ) {
            console.log('This timer is already going!');
            return;
        }

        // Reset all tasks.
        newTaskList = newTaskList.map( task => {
            task.isActive = false;
            return task;
        } );

        // Set the current task to active.
        currentTask.isActive = true;

        // Add a new event.
        let event = {
            taskId: e.target.id,
            startTime: timestamp.unix(),
            endTime : null
        };
        this.createEvent(event);
    }

    render() {
        const taskList = [...this.state.tasks];
        if (taskList.length === 0) {
            return (
                <TaskContainer>
                    <TaskForm create={this.createTask}/>
                </TaskContainer>
            )
        }

        return(
            <TaskContainer>
                <TaskForm create={this.createTask}/>
                <TaskListContainer>
                {
                    taskList.map( (task, id) => (
                        <TaskButton startTimer={this.startTimer} task={task} key={id} id={task.key}/>
                        ))
                    }
                </TaskListContainer>
            </TaskContainer>
        )
    }
}

export default Tasks;


// WEBPACK FOOTER //
// ./src/components/Tasks.js